import { LoadingButton } from "@mui/lab"
import { t } from "i18next"

interface SaveAndContinueButtonProps {
    loading?: boolean
    onClick: () => void
}

const SaveAndContinueButton = (props: SaveAndContinueButtonProps) => {
    const { loading, onClick } = props
    return (
        <LoadingButton
            loading={loading}
            variant="contained"
            color="primary"
            size="large"
            onClick={onClick}>
            {t(`save_and_continue`, { ns: `common` })}
        </LoadingButton>
    )
}

export { SaveAndContinueButton }
